import { Drawer } from 'antd';
import React, { memo } from 'react';
import styles from './FilterDrawerPermits.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as FilterIcon } from '../../../../../../resource/FilterDocumentIcon.svg';
import FormFilter from '../FormFilter/FormFilter';
import {
  changeVisiblePermitFilter,
  resetPermitFilter,
} from '../../../../shared/store/action';
import FooterFilter from '../FooterFilter/FooterFilter';

const FilterHeader = memo(() => {
  return (
    <div className={styles.header}>
      <FilterIcon />
      <div>Фильтр пропусков</div>
    </div>
  );
});

const FilterDrawerPermits = () => {
  const dispatch = useDispatch();

  const { visiblePermitFilter, filterChanged } = useSelector(
    (state) => state.permitsFilterStore
  );

  const handleClose = (e) => {
    e.preventDefault();

    dispatch(changeVisiblePermitFilter(false));
  };

  const handleResetFilter = (e) => {
    e.preventDefault();

    dispatch(resetPermitFilter());
  };

  return (
    <Drawer
      visible={visiblePermitFilter}
      title={<FilterHeader />}
      width="min(760px, 100vw)"
      headerStyle={{ position: 'sticky', top: 0, zIndex: 10 }}
      closable={true}
      drawerStyle={{ backgroundColor: '#F3F7FF' }}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        height: '95%',
        padding: 0,
      }}
      onClose={handleClose}
    >
      <div style={{ flex: 1 }}>
        <FormFilter />
      </div>
      <FooterFilter
        onClose={handleClose}
        onReset={handleResetFilter}
        disabled={!filterChanged}
      />
    </Drawer>
  );
};

export default FilterDrawerPermits;
